import { fetchJSONWithAuth } from "./hikoFetch";


export async function getAdminUsers(mahiContext) {
    console.log('getAdminUsers');

    const options = {
        method: 'GET',
        headers: {
        },
    };
    const bffPath = '/bff/user-management-service-mahi/api/users/all';
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
    return response;
}

export async function postAdminUserRoles(mahiContext, userId, roles) {
    console.log('postAdminUserRoles userId', userId);

    // const jsonRoles = JSON.stringify(roles)
    console.log('postAdminUserRoles roles', roles);

    if (!userId) {
        throw new Error(`User name required when posting user roles.`);
    }
    const options = {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify({
            userId,
            roles,
        })
    };
    const bffPath = `/bff/user-management-service-mahi/api/users/${userId}/update-roles`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
    return response;
}

export async function postAdminCreateUser(mahiContext, {name, email, phone}) {
    console.log('postAdminCreateUser user:', {name, email, phone})

    if (!name || !email) {
        throw new Error(`Name and email are required`)
    }
    const options = {
        method: 'POST',
        headers: {
        },
        body: JSON.stringify({
            oid: null,
            name,
            email,
            phone,
            roles: ['Mahi.User'],
        })
    };
    const bffPath = `/bff/user-management-service-mahi/api/users/create`;
    const queryParams = {
    }
    const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
    return response;
}

export async function patchAdminEditUser(mahiContext, {id, name, email, phone, account}) {
  console.log('patchAdminEditUser user:', {id, name, email, phone, account});

  const options = {
      method: 'PATCH',
      headers: {
      },
      body: JSON.stringify({
          name,
          email,
          phone,
          accountId: account?.accountId || null,
      })
  };
  const bffPath = `/bff/user-management-service-mahi/api/users/${id}/update-properties`;
  const queryParams = {
  }
  const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
  return response;
}

export async function getAccounts(mahiContext) {
  console.log('getAccounts');

  const options = {
      method: 'GET',
      headers: {
      },
  };
  const bffPath = '/bff/user-management-service-mahi/api/accounts/all';
  const queryParams = {
  }
  const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
  return response;
}

export async function postCreateAccount(mahiContext, {accountId, name, email, phone}) {
  console.log('postCreateAccount called', {accountId, name, email, phone});

  if (!accountId || !name || !email) {
      throw new Error(`Account Id, Name and Email are required when creating an Account.`);
  }
  const options = {
      method: 'POST',
      headers: {
      },
      body: JSON.stringify({
          accountId,
          name,
          email,
          phone
      })
  };
  const bffPath = `/bff/user-management-service-mahi/api/accounts/create`;
  const queryParams = {
  }
  const response = await fetchJSONWithAuth(mahiContext, 'bffMahi', bffPath, queryParams, options);
  return response;
}